import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { dataAccessOf } from "@/lib/dataAccess";
import { Card } from "@/components/ui/Card";

/** หน้าแจ้ง "ไม่มีสิทธิ์" — ใช้แทนหน้าข้อมูลสำหรับคนที่ไม่มีสิทธิ์ดู (ไม่ยิง API ข้อมูลเลย) */
export function NoDataPermission() {
  return (
    <Card className="mx-auto mt-10 max-w-md">
      <div className="flex flex-col items-center gap-3 py-6 text-center">
        <Lock aria-hidden className="h-8 w-8 text-slate-400" />
        <p className="font-heading text-base font-semibold text-slate-900">ยังไม่มีสิทธิ์ดูข้อมูลนี้</p>
        <p className="text-sm text-slate-500">ติดต่อผู้ดูแลระบบ</p>
      </div>
    </Card>
  );
}

/**
 * กันหน้าข้อมูล (ภาพรวม เซียน ลูกค้า เกม ผู้แนะนำ) — คนที่ไม่มีสิทธิ์ (dataAccessOf = "none") เห็นหน้าแจ้งแทน
 * หน้าจะไม่ถูก render จึงไม่ยิง API ข้อมูลเลย · backend ตอบ 403 / ว่าง อยู่แล้วอีกชั้น
 */
export function RequireDataAccess({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (dataAccessOf(user) === "none") return <NoDataPermission />;
  return <>{children}</>;
}

/**
 * หน้าแรก (/) — คนที่ไม่มีสิทธิ์ดูข้อมูลแต่มีทีม (เช่น role user) ไปหน้า บัญชีโฆษณา 2 เลย
 * ไม่มีทีม = หน้าแจ้งไม่มีสิทธิ์
 */
export function HomeRoute({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (dataAccessOf(user) !== "none") return <>{children}</>;
  if (user?.group_id != null) return <Navigate to="/ad-accounts2" replace />;
  return <NoDataPermission />;
}
